<template>
  <div class="artwork row align-items-center justify-content-center justify-content-xl-around">
    <div class="col-8 pt-3 pt-md-0 col-md-4">
      <h4 class="header">Ethereality</h4>
      <img
        class="rounded img-fluid"
        src="../../public/assets/portrait.jpg"
      />
    </div>
    <div class="col-8 pt-4 pt-md-2 col-md-4">
        <h4 class="header">Phantom Dragon</h4>
        <img
          class="rounded img-fluid"
          src="../../public/assets/reptile.png"
        />
    </div>
    <div class="col-8 pt-4 pt-md-2 col-md-3">
        <h4 class="header">Perfect Illusion</h4>
        <img
          class="rounded img-fluid"
          src="../../public/assets/perfect_illusion.jpg"
        />
    </div>
  </div>    
</template>

<script>

export default {
  // eslint-disable-next-line
  name: 'Artwork'
}
</script>

<style>

.header {
  color: white;
}

</style>
